import React from "react";
import OrionSprite from "../assets/svg/orion-svg-sprite-minimal.svg";
import { jsx as _jsx } from "react/jsx-runtime";

var Icons = function Icons() {
  return /*#__PURE__*/_jsx("div", {
    style: {
      position: "absolute"
    },
    children: /*#__PURE__*/_jsx(OrionSprite, {})
  });
};

export default Icons;